import { Outlet } from '@tanstack/react-router';
import { Toaster } from 'sonner';

const Root = () => (
  <>
    <Outlet />
    <Toaster />
  </>
);

export default Root;
